import { EDITOR_ORIGIN } from '~/constants/editor';

import { Hint } from './Hint';

class EmojiHint implements Hint {
  name = 'emoji';

  origin = EDITOR_ORIGIN.EMOJI_COMPLETE;

  fromDistance = 1;

  emojiRegex = /(?:\s|^):([^: ][a-z0-9\-_+]*)$/i;

  checkActive(text: string): boolean {
    const matches = this.emojiRegex.exec(text);
    return matches && matches.length > 1 && matches[1].length >= 2;
  }

  convertItemToText({ value }: { value: string }) {
    return `:${value}:`;
  }

  getQuery(text: string): string {
    const result = this.emojiRegex.exec(text);
    return result ? result[1] : '';
  }
}

export default new EmojiHint();
